/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_SparseInputs */

const en_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparse Text (Scattered)`)
};

const fr_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte épars (dispersé)`)
};

const de_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenig Text (verstreut)`)
};

const it_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo sparso (disseminato)`)
};

const ru_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрозненный текст (рассеянный)`)
};

const es_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto disperso (disperso)`)
};

const zh_cn2_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀疏文本（散乱）`)
};

const ja_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`疎なテキスト（散在）`)
};

const hi_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिखरा हुआ पाठ (अस्त-व्यस्त)`)
};

const pt_pt2_ocr_psm_sparse = /** @type {(inputs: Ocr_Psm_SparseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto esparso (disperso)`)
};

/**
* | output |
* | --- |
* | "Sparse Text (Scattered)" |
*
* @param {Ocr_Psm_SparseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_sparse = /** @type {((inputs?: Ocr_Psm_SparseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_SparseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_psm_sparse(inputs)
	if (locale === "de") return de_ocr_psm_sparse(inputs)
	if (locale === "it") return it_ocr_psm_sparse(inputs)
	if (locale === "ru") return ru_ocr_psm_sparse(inputs)
	if (locale === "es") return es_ocr_psm_sparse(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_psm_sparse(inputs)
	if (locale === "ja") return ja_ocr_psm_sparse(inputs)
	if (locale === "hi") return hi_ocr_psm_sparse(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_psm_sparse(inputs)
	return en_ocr_psm_sparse(inputs)
});